import { render, staticRenderFns } from "./AppCardCaption.vue?vue&type=template&id=520e8d3f&scoped=true&lang=pug&"
import script from "./AppCardCaption.vue?vue&type=script&lang=js&"
export * from "./AppCardCaption.vue?vue&type=script&lang=js&"
import style0 from "./AppCardCaption.vue?vue&type=style&index=0&id=520e8d3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e8d3f",
  null
  
)

export default component.exports